import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const flightApi = createApi({
  reducerPath: "flightApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/v1/travel/flights`,
  }),
  tagTypes: ["Flights"],
  endpoints: (builder) => ({
    getFlights: builder.query<any[], void>({
      query: () => "/",
      providesTags: ["Flights"],
    }),
    createFlight: builder.mutation<any, any>({
      query: (flight) => ({ url: "/", method: "POST", body: flight }),
      invalidatesTags: ["Flights"],
    }),
    updateFlight: builder.mutation<any, { id: string; flight: any }>({
      query: ({ id, flight }) => ({
        url: `/${id}`,
        method: "PUT",
        body: flight,
      }),
      invalidatesTags: ["Flights"],
    }),
    deleteFlight: builder.mutation<any, string>({
      query: (id) => ({ url: `/${id}`, method: "DELETE" }),
      invalidatesTags: ["Flights"],
    }),
  }),
});

export const {
  useGetFlightsQuery,
  useCreateFlightMutation,
  useUpdateFlightMutation,
  useDeleteFlightMutation,
} = flightApi;
